import SearchIcon from '@mui/icons-material/Search'
import {
  Box,
  CircularProgress,
  InputAdornment,
  Stack,
  TextField,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAddressSearch } from '../../hooks/address/useAddressSearch'
import { AddressSelector } from '../../store/Address'
import { SuggestionContainer } from './SuggestionContainer'
import { SuggestionItem } from './SuggestionItem'
import { SuggestionError } from './SuggestionError'


export const AddressSearchForm = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const {
    isLoading,
    error,
    address,
    suggestions,
    setAddress,
    handleManualInputChange,
    handleSuggestionClick,
    handleSubmit
  } = useAddressSearch()

  const selectedAddress = useSelector(AddressSelector.selectAddress)

  useEffect(() => {
    if (!selectedAddress) {
      setAddress({
        streetAndNumber: '',
        place: '',
        region: '',
        postcode: '',
        country: '',
        latitude: 0,
        longitude: 0,
      })
    }
  }, [selectedAddress, setAddress])

  return (
    <Stack width={{ flex: '1 0 auto' }} flexDirection="row" justifyContent="center" alignItems='center' position="relative">
      <Box sx={{position:'relative', maxWidth: '375px', flex:'1 0 auto'}}>
      <TextField
        value={address.streetAndNumber}
        onChange={handleManualInputChange}
        placeholder="Search address"
        error={!!error}
        sx={{
          width: isMobile ? '100%' : 375,
          borderRadius: '8px',
          bgcolor: isMobile ? 'white' : '#F3F6F8',
          '& .MuiOutlinedInput-root': {
            height: isMobile ? 40 : 36,
            borderRadius: '8px',
            fontSize: '14px',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: error ? 'error.main' : '#E2E8F0 !important',
          },
          '& .Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: 'error.main !important',
            borderWidth: '1px',
          },
        }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                {isLoading ? (
                  <CircularProgress size={20} />
                ) : (
                  <SearchIcon
                    onClick={handleSubmit}
                    sx={{ cursor: 'pointer', color: error ? 'error.main' : 'inherit' }} />
                )}
              </InputAdornment>
            ),
          }
        }}
      />

      {(suggestions.length > 0 || error) && (
        <SuggestionContainer error={error}>
          {error && (<SuggestionError error={error}/>)}
          {!error && suggestions.length > 0 && suggestions.map((suggestion, index) => (
            <SuggestionItem key={suggestion.id} data={suggestion} handleClick={handleSuggestionClick(suggestion)} />
          ))}
        </SuggestionContainer>
      )}
      </Box>
    </Stack>
  )
}
